export const formErrors = {
  required: 'Required',
  min3: 'Minimum 3 symbols',
  min6: 'Minimum 6 symbols',
  max20: 'Maximum 20 symbols',
  email: 'Invalid email',
}
